import css from "styled-jsx/css";

export const picOverlayStyles = css.global`
  .picture-with-overlay {
    .overlay-image-container {
      cursor: pointer;
      .zoom-in {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        opacity: 0;
        transition: opacity 0.3s;
      }
      &:hover {
        .zoom-in {
          opacity: 1;
        }
      }
    }
    .overlay-image-text-only {
      text-align: center;
    }
  }
`;
